import PatientsTable from "../../../components/PatientsTable/PatientsTable";

function ClinicPatients() {
    return (
        <>
            <PatientsTable userType={2} />
        </>
    )
}

export default ClinicPatients;
